import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { css } from '@linaria/core'
import { ArrowCaret } from '@fs/zion-icon'
import { colors, Row } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

const lessButton = css`
  display: flex;
  align-items: center;
  color: ${colors.transparent.gray70};
  background: none;
  border: none;
  font-size: 14px;
  margin-inline-start: -5px;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
  &:focus-visible {
    outline: 2px solid ${colors.blue70};
    outline-offset: 2px;
    border-radius: 4px;
  }
  span {
    margin-inline-end: 8px;
  }
`

export default function FooterCollapseButton({ onClick, shouldFocus }) {
  const { t } = useTranslation()
  const buttonRef = useRef(null)

  useEffect(() => {
    if (shouldFocus) {
      buttonRef.current?.focus()
    }
  }, [shouldFocus])

  return (
    <Row alignX="end">
      <button
        ref={buttonRef}
        className={lessButton}
        type="button"
        onClick={onClick}
        name="footer_less"
        aria-label={t('footer.collapse', 'Collapse footer - less')}
      >
        <span>{t('common-ui:show-less.info.abbr', 'Less')}</span>
        <ArrowCaret background={colors.transparent.gray70} color="white" size="xs" direction="up" />
      </button>
    </Row>
  )
}

FooterCollapseButton.propTypes = {
  onClick: PropTypes.func,
  shouldFocus: PropTypes.bool,
}
